import React from 'react';

const WorkOrderStep6Safety = ({ formData, setFormData, formErrors }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="step-form">
      <div className="form-section">
        <h3 className="section-title">Safety Section</h3>
        <div className="form-group checkbox-group flexrow">
          <input
            type="checkbox"
            id="lockoutTagoutRequired"
            name="lockoutTagoutRequired"
            checked={formData.lockoutTagoutRequired}
            onChange={handleChange}
          />
          <label htmlFor="lockoutTagoutRequired">Lockout/Tagout Required?</label>
        </div>
        <div className="form-group">
          <label htmlFor="safetyInstructions">Safety Instructions</label>
          <textarea
            id="safetyInstructions"
            name="safetyInstructions"
            value={formData.safetyInstructions}
            onChange={handleChange}
            placeholder="Enter safety instructions and precautions..."
            rows="4"
          />
        </div>
        <div className="form-group">
          <label htmlFor="riskLevel">Risk Level</label>
          <select
            id="riskLevel"
            name="riskLevel"
            value={formData.riskLevel}
            onChange={handleChange}
          >
            <option value="">Select Risk Level</option>
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderStep6Safety;

